var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageLoader',{attrs:{"storage":_vm.appLoading}}),(_vm.ServerError)?_c('ServerError'):_vm._e(),_c('v-app',{staticStyle:{"background-color":"#ebf0ff"}},[_c('v-snackbar',{attrs:{"color":"#7CB9E8","right":"","timeout":_vm.timeout},model:{value:(_vm.showSnackBar),callback:function ($$v) {_vm.showSnackBar=$$v},expression:"showSnackBar"}},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"align-self-center",attrs:{"text-left":""}},[_vm._v(_vm._s(_vm.msg))]),_c('v-flex',{attrs:{"text-right":""}},[_c('v-btn',{attrs:{"small":"","ripple":false,"text":""},on:{"click":function($event){_vm.showSnackBar = false}}},[_c('v-icon',{staticStyle:{"color":"white"}},[_vm._v("mdi-close")])],1)],1)],1)],1),(
        _vm.$route.name != 'Login' &&
        _vm.$route.name != 'Register' &&
        _vm.$route.name != 'Forgot' &&
        _vm.$route.name != 'CheckEmail' &&
        _vm.$route.name != 'Verify'
      )?_c('AppHeader',{on:{"stepper":_vm.winStepper}}):_vm._e(),_c('router-view',{attrs:{"storage":_vm.sideNav}}),(
        _vm.$route.name != 'Login' &&
        _vm.$route.name != 'Register' &&
        _vm.$route.name != 'Forgot' &&
        _vm.$route.name != 'CheckEmail' &&
        _vm.$route.name != 'Verify'
      )?_c('AppFooter'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }